import React from 'react';
import { OfferBuyCards } from '../../../../shared/logicalComponents';
import AssetOptions from '../../AssetOptions/AssetOptions';
import useSelectedIndex from '../../../../hooks/stateful/useSelectedIndex';
import LicenseMessage from '../../Messages/LicenseMessage/LicenseMessage';

const AlaCarteLicenseForm = () => {
  const { selectedOption } = useSelectedIndex();

  return (
    <div data-testid="alacarte-license-form">
      <AssetOptions />
      <LicenseMessage />
      {selectedOption?.type !== 'customlicense' && (
        <OfferBuyCards includeSubscription={false} />
      )}
    </div>
  );
};

export default AlaCarteLicenseForm;
